namespace AgerLMS.WebSite {

    //https://ajax.aspnetcdn.com/ajax/jquery.validate/1.11.1/additional-methods.js
    @Serenity.Decorators.registerClass()
    export class NewPasswordWidget extends Serenity.Widget<Membership.ResetPasswordRequest> {

        button : string = "#NewPasswordButton";
        formSelector : string = "#NewPasswordForm";

        constructor(element: JQuery, opt: Membership.ResetPasswordRequest) {
            super(element, opt);

            var form = $(this.formSelector);

            this.bindValidate();

            $(this.button).click(e => {
                e.preventDefault();

                if (!$(this.formSelector).valid()) return;
                
                var request = <Membership.ResetPasswordRequest>{};
                request.Token = form.find("input[name='resetToken']").val();
                request.NewPassword = form.find("input[name='password']").val();
                request.ConfirmPassword = form.find("input[name='password_confirmation']").val();
                Q.serviceCall({
                    url: Q.resolveUrl('~/Account/ResetPassword'),
                    request: request,
                    onSuccess: response => {
                        Swal.fire({
                            title: 'Yeni şifreniz oluşturuldu! Sistemi Kullanmaya Başlayabilirsiniz.',
                            text: 'Giriş sayfasına yönleniyor. Lütfen Bekleyiniz...',
                            icon: 'success',
                            timer: 2000,
                            buttons: false,
                        })
                        .then(() => {
                            window.location.href = Q.resolveUrl('~/giris');;
                        })
                    }
                });
            });

            $(document).keypress(function(e){
                if (e.which == 13){
                    $(this.button).click();
                }
            });
        }

        private bindValidate() {
            var self = this;

            $(".reveal").on('click',function() {
                var $password = $(this).parent().children("input");
                var $i = $(this).children().children("i");
                if ($password.attr('type') === 'password') {
                    $password.attr('type', 'text');
                    $i.removeClass("fa-eye-slash");
                    $i.addClass("fa-eye");
                } else {
                    $password.attr('type', 'password');
                    $i.removeClass("fa-eye");
                    $i.addClass("fa-eye-slash");
                }
            });

            $(self.formSelector).validate({
                errorClass: "is-invalid",
                rules: {
                    password: {
                        required: true,
                        minlength: 8
                    },
                    password_confirmation: {
                        required: true,
                        equalTo: "[name='password']"
                    }           
                },
                messages: {
                    password: {
                        required: "* Yeni Şifrenizi belirtin",
                        minlength:"* Yeni Şifreniz en az 8 karakter olmalıdır!"
                    },
                    password_confirmation: {
                        required: "* Yeni Şifrenizi tekrar girin",
                        equalTo:"* Şifreleriniz uyuşmuyor!"
                    }
                },
                errorPlacement: function(error, element) {
                    $(element).parents('.form-group').append(error)
                }
            });
        }
    }
}